export default {"src":"/_next/static/media/comma.e564984a.svg","height":68,"width":74,"blurWidth":0,"blurHeight":0};